/** @jsx jsx */
/** @jsxFrag React.Fragment */

// eslint-disable-next-line
import React from "react";
import { jsx, css } from "@emotion/core";
import { useAuth0 } from "@auth0/auth0-react";
import { Logo, Button, Flex, Box, theme } from "@xometry/xometry_loft";
import { Link } from "react-router-dom";

const Header = (): JSX.Element => {
  const {
    isLoading,
    error,
    user,
    isAuthenticated,
    loginWithPopup,
    logout,
  } = useAuth0();

  let loginLabel: string | JSX.Element;
  if (isLoading) {
    loginLabel = "\u2026";
  } else if (error) {
    loginLabel = <div title={error.toString()}>Login error</div>;
  } else if (isAuthenticated) {
    loginLabel = user.name;
  } else {
    loginLabel = "Not logged in";
  }

  let loginButton: JSX.Element | null;
  if (isLoading) {
    loginButton = null;
  } else if (error || !isAuthenticated) {
    loginButton = (
      <Button scale="small" onClick={loginWithPopup}>
        Log In
      </Button>
    );
  } else {
    loginButton = (
      <Button
        scale="small"
        onClick={() => logout({ returnTo: window.location.href })}
      >
        Logout
      </Button>
    );
  }

  return (
    <Flex
      flexDirection="row"
      alignItems="middle"
      css={css`
        padding: 2px 10px;
        border-bottom: 1px solid ${theme.colors.brandBlue};
        margin-bottom: 1px;
      `}
    >
      <Box>
        <Link to="/">
          <Logo />
        </Link>
      </Box>
      <Box
        flex="1"
        css={css`
          text-align: center;
        `}
      >
        <h1>API Catalog</h1>
      </Box>
      <Box
        id="auth-header"
        flex="1"
        css={css`
          text-align: right;
        `}
      >
        <Flex flexDirection="column">
          <Box>{loginLabel}</Box>
          <Box
            css={css`
              margin-top: ${theme.space[2]};
            `}
          >
            {loginButton}
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Header;
